import { generateRandomId } from './generateRandomId'

export const generateInputRandomName = () => {
    return `input-${generateRandomId()}`
}
